import { Navigate, Outlet } from "react-router-dom";
import { useRecoilValue } from "recoil";
import authAtom from "stores/auth";

// 인증없는 라우터
const PublicRoute = () => {
  const { isLogin } = useRecoilValue(authAtom);

  return isLogin ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;
